import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_CACHE_KEY = "mfg:map-config";
let tokenPromise = null;
let mapConfig = null;
try { const c = JSON.parse(sessionStorage.getItem(TOKEN_CACHE_KEY) || "null"); if (c?.mapbox_token && Date.now() - (c._at || 0) < 6 * 3600 * 1000) { mapConfig = c; tokenPromise = Promise.resolve(c.mapbox_token); } } catch { /* no cache */ }
export const getMapboxToken = () => {
  if (!tokenPromise) tokenPromise = axios.get(`${API}/public/map-config`).then((r) => {
    mapConfig = r.data || null;
    try { if (mapConfig?.mapbox_token) sessionStorage.setItem(TOKEN_CACHE_KEY, JSON.stringify({ ...mapConfig, _at: Date.now() })); } catch { /* quota */ }
    return r.data?.mapbox_token || "";
  }).catch(() => "");
  return tokenPromise;
};
export const prefetchMapboxToken = () => { getMapboxToken(); };
export const getMapConfig = () => mapConfig;
export const hasWebGL2 = () => {
  try { const c = document.createElement("canvas"); return !!(c.getContext("webgl2") || c.getContext("webgl")); } catch { return false; }
};
